<template>
    <v-snackbar
            v-model="snackbar"
            :color="color"
            :multi-line="mode"
            :timeout="timeout"
            :vertical="mode === 'vertical'"
            right
            top
    >
        {{ text }}
        <v-btn
                dark
                flat
                @click="snackbar = false"
        >
            Close
        </v-btn>
    </v-snackbar>
</template>

<script>
    export default {
        data () {
            return {
                snackbar: false,
                mode: 'multi-line',
                timeout: 6000,
            }
        },
        computed: {
            text: function () {
                return this.$store.getters.getText;
            },
            color: function () {
                return this.$store.getters.getColor;
            },
            notify: function () {
                return this.$store.getters.getNotify;
            },
        },
        watch: {
            notify: function (nuevo, old) {
                if (nuevo == true) {
                    this.snackbar = true;
                }
            },
            snackbar: function (newSnack, oldSnack) {
                if (newSnack == false) {
                    this.$store.commit('setNotify', {
                        state: false,
                        text: null,
                        color: null
                    });
                }
            }
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/NotifyComponent.vue